export default __webpack_public_path__ + "static/media/pay respects 3.d1e53461.png";